export default __webpack_public_path__ + "static/zflow-link-fgts-img-bebe803d7d23bcaee57f09a1868904f5.png";